// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1771":"f99d42ef","4457":"f99d42ef"}[chunkId] + ".chunk.css";
};